export default __webpack_public_path__ + "static/media/jobs.3c793ce8.svg";